import {
	EssityColumnProps,
	filterType,
} from '@components/shared/paginatedEssityTable/GridHelper';
import { useRootData } from '@hooks/hook';
import { DictionariesConstants } from '@services/DictionariesConstants';
import { PharmacyDto } from '@services/src/models';
import { IDictionaryStore } from 'stores/DictionaryStore';

export const GetPortalAccountsTableExpandedColumn = (): EssityColumnProps<PharmacyDto>[] => {
	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);

	const getVoivodeshipColumn = () => {
		return {
			sorter: true,
			dataIndex: 'voivodeshipId',
			width: 160,
			key: 'voivodeshipId',
			title: 'Voivodeship',
			filter: 'equals' as filterType,
			hideFilterIcon: true,
			render: (value: number) => {
				return dictionaryStore.getValueById(
					DictionariesConstants.Voivodeships,
					value
				);
			},
		};
	};

	let columns: EssityColumnProps<PharmacyDto>[] = [
		{
			dataIndex: 'placeId',
			key: 'placeId',
			title: 'SAP ID',
			width: 100,
			sorter: true,
			filter: 'equals' as filterType,
		},
		{
			dataIndex: 'kodKom',
			key: 'kodKom',
			title: 'Kod Kom',
			width: 110,
			sorter: true,
			filter: 'equals' as filterType,
		},
		{
			dataIndex: 'nhfContractId',
			key: 'nhfContractId',
			title: 'NHF contract',
			width: 150,
			render: (value: number, _record: PharmacyDto, _index: number) => {
				return dictionaryStore.getValueById(
					DictionariesConstants.NHFContract,
					value
				);
			},
			sorter: true,
			filter: 'dictionary' as filterType,
			filterDictionary: DictionariesConstants.NHFContract,
		},
		{
			dataIndex: 'automaticNoteSending',
			key: 'automaticNoteSending',
			title: 'CNA',
			width: 100,
			render: (value: boolean) => (value ? 'Tak' : 'Nie'),
			sorter: true,
			filter: 'checkbox' as filterType,
			filterDictionary: DictionariesConstants.TrueOrFalse,
		},
		{
			dataIndex: 'name',
			key: 'name',
			title: 'Name',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		getVoivodeshipColumn(),
		{
			dataIndex: 'city',
			key: 'city',
			title: 'City',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'street',
			key: 'street',
			title: 'Street',
			width: 150,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'taxNumber',
			key: 'taxNumber',
			title: 'NIP',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'pharmacyChain',
			key: 'pharmacyChain',
			title: 'Pharmacy Chain',
			width: 160,
			sorter: true,
			filter: 'contains' as filterType,
		},
		{
			dataIndex: 'companyName',
			key: 'companyName',
			title: 'Company Name',
			width: 200,
			sorter: true,
			filter: 'contains' as filterType,
		},
	];
	return columns;
};
